export default __webpack_public_path__ + "static/media/Hockey_09.b6cc7d28.png";